import { IMAGES } from "@/site";
import { PageHero, Section, SectionTitle, BulletGrid, CTABand } from "@/components/ui-blocks/Blocks";

const BLOCKS = [
  {
    title: "School Bus Driver Training Support",
    body: "CLB Solution helps new and developing drivers prepare for the responsibilities of school bus operation.",
    items: [
      "School bus safety","Pre-trip inspection","Vehicle familiarization","Professional responsibilities","Student safety","Mirror use","Danger zones","Loading and unloading","Railroad crossings","Right turns","Left turns","Backing awareness","Defensive driving","Emergency procedures","Communication and professionalism"
    ],
  },
  {
    title: "Pre-Trip Inspection Training",
    body: "A proper pre-trip inspection is one of the most important parts of school bus safety. CLB Solution provides detailed training on the full inside and outside school bus inspection.",
    items: [
      "Engine compartment","Lights and reflectors","Tires and wheels","Suspension","Brakes","Steering","Frame","Exhaust system","Fuel area","Stop arm","Crossing gate","Student loading lights","Emergency exits","Seats and aisle","Driver controls","Gauges","Mirrors","Child check system","Emergency equipment"
    ],
  },
  {
    title: "Refresher Training",
    body: "Designed for drivers who need to review procedures, rebuild confidence, or sharpen their skills.",
    items: [
      "Returning drivers","Drivers returning after medical leave","Drivers who have not driven recently","Drivers needing updated safety review","Drivers needing confidence behind the wheel","Drivers needing pre-trip review"
    ],
  },
  {
    title: "Corrective / Remedial Training",
    body: "Designed to address unsafe habits, prevent repeat incidents, and improve driver decision-making.",
    items: [
      "Tail swing accidents","Mirror use errors","Poor turns","Backing incidents","Stationary object strikes","Unsafe following distance","Poor decision-making","Distracted driving","Aggressive driving habits","Loading and unloading errors","Failure to follow proper procedures","Speed and space management concerns"
    ],
  },
  {
    title: "District Support Services",
    body: "Built to support transportation departments, districts, and contractors through training resources and safety-focused driver development.",
    items: [
      "New driver training support","Safety workshops","Pre-trip inspection programs","Refresher training","Corrective training","Driver evaluations","Driver readiness assessments","Training handouts","Digital learning resources","Future staffing support"
    ],
  },
];

export default function Services() {
  return (
    <>
      <PageHero
        testid="services-hero"
        eyebrow="Our Services"
        title="Training, coaching, and workforce development."
        description="CLB Solution LLC is preparing to offer school bus driver training support, safety education, and workforce development services for individual trainees, current drivers, returning drivers, transportation departments, and contractors."
        image={IMAGES.services}
      />

      <Section testid="services-pricing-note">
        <div className="border-l-4 border-[#FFCC00] bg-[#0c0c0e] p-6 md:p-8">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#FFCC00] mb-2 font-semibold">Note</div>
          <p className="text-white/80">
            Pricing and service availability may vary based on training needs, program structure,
            and organizational support. Contact CLB Solution directly for information.
          </p>
        </div>
      </Section>

      {BLOCKS.map((b, i) => (
        <Section key={b.title} testid={`services-block-${i}`} className={i % 2 === 1 ? "bg-[#0c0c0e] border-y border-white/10" : ""}>
          <div className="grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-4">
              <div className="font-mono text-xs text-[#FFCC00] mb-3">{String(i + 1).padStart(2, "0")} / Service</div>
              <h2 className="font-display text-3xl md:text-4xl font-bold uppercase tracking-tight leading-[1]">
                {b.title}
              </h2>
              <p className="mt-4 text-white/65 leading-relaxed">{b.body}</p>
            </div>
            <div className="lg:col-span-8">
              <BulletGrid items={b.items} testid={`services-block-${i}-items`} />
            </div>
          </div>
        </Section>
      ))}

      <CTABand title="Want to bring CLB Solution to your district?" description="Reach out for a conversation about training support, refresher programs, or workforce development." />
    </>
  );
}
